// extracted by mini-css-extract-plugin
module.exports = {"button":"Button_button__2l0sK","smallBorder":"Button_smallBorder__3Jm3A","mediumBorder":"Button_mediumBorder__2RbW7","largeBorder":"Button_largeBorder__1HKfd"};